import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import FullScreenDialog from 'components/FullScreenDialog';
import ItemDetails from 'components/Store/ItemDetails';
import Loader from 'components/Material/Loader';
import { Units, Colors } from 'Css';
import CoursioLogo from 'components/CoursioLogo';
import PoweredBy from 'Cio/Assets/PoweredBy';
const isValidEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
import { TextField, RaisedButton } from 'material-ui';

const css = oxygenCss({
  root: {
    padding: Units.base
  },
  details: {},
  logo: {
    borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: '#DDD',
    padding: Units.base * 2,
    lineHeight: '32px',
    textAlign: 'center',
    color: '#09BEC3',
    fontSize: '24px',
    ' >SPAN': {
      verticalAlign: 'middle',
      marginLeft: '8px'
    }
  },
  method: {
    textAlign: 'right',
    '>DIV': {
      display: 'inline-block',
      width: 128,
      textAlign: 'left'
    }
  },
  container: {
    margin: Units.base * 3,
    width: 'auto',
    '@desktop': {
      width: 365,
      margin: `${Units.keyline}px ${Units.keyline * 2}px`
    }
  },

  courseBought: {
    textAlign: 'center',
    padding: Units.keyline
  },
  error: {
    fontSize: '24px',
    display: 'inline',
    color: '#FF3030'
  },
  backButton: {
    cursor: 'pointer',
    position: 'relative',
    height: 32,
    minWidth: 72,
    top: -16,
    left: 24,
    display: 'inline-block',
    lineHeight: '32px',
    padding: `0 ${Units.base * 2}px`,
    borderRadius: 16,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
    '@phone': {
      position: 'absolute',
      left: 16,
      top: 16
    },
    '>SVG': {
      verticalAlign: 'middle',
      marginRight: Units.base
    }
  },
  explanation: {
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: '0.1px',
    whiteSpace: 'pre-line',
    color: '#686868'
  }
});

class GiftEmailForm extends Component {
  static propTypes = {};

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    history: PropTypes.object
  };

  state = {
    emailError: null,
    giftEmailError: null,
    giftEmail: null,
    giftEmailConfirm: null
  };

  validEmail(email) {
    return isValidEmail.test(email.toLowerCase());
  }

  _handleEmailChange = event => {
    const { value: giftEmail } = event.target;
    if (!this.validEmail(giftEmail)) {
      this.setState({
        giftEmail,
        emailError: this.context.getIntlMessage('validation.invalidEmail')
      });
    } else {
      this.setState({ giftEmail, emailError: null });
    }
  };

  setGiftEmail = () => {
    StoreOverviewActions.setGiftEmail(this.state.giftEmail);
  };

  _handleEmailConfirmChange = event => {
    const { value: giftEmailConfirm } = event.target;
    const { giftEmail } = this.state;
    if (!this.validEmail(giftEmailConfirm)) {
      this.setState({
        giftEmailConfirm,
        giftEmailError: this.context.getIntlMessage('validation.invalidEmail')
      });
    } else if (giftEmailConfirm !== giftEmail) {
      this.setState({
        giftEmailConfirm,
        giftEmailError: this.context.getIntlMessage('gift.emailMustMatch')
      });
    } else {
      this.setState({ giftEmailConfirm, giftEmailError: null });
    }
  };

  back = () => {
    StoreOverviewActions.clearCart(null);
  };

  render() {
    const { getIntlMessage } = this.context;
    const {
      giftEmail,
      giftEmailConfirm,
      emailError,
      giftEmailError
    } = this.state;
    const canContinue =
      giftEmail === giftEmailConfirm &&
      !!giftEmail &&
      !giftEmailError &&
      !giftEmailError;
    return (
      <div className={css.details}>
        <div className={css.container}>
          <h1>{getIntlMessage('gift.thisCourse')}</h1>
          <p className={css.explanation}>
            {getIntlMessage('gift.explanation')}
          </p>
          <p className={css.explanation}>
            <b>{getIntlMessage('gift.warning')}</b>
          </p>
          <TextField
            fullWidth
            hintText={getIntlMessage('gift.email')}
            value={giftEmail}
            errorText={emailError}
            onChange={this._handleEmailChange}
          />
          <TextField
            fullWidth
            hintText={getIntlMessage('gift.confirm')}
            errorText={giftEmailError}
            value={giftEmailConfirm}
            onChange={this._handleEmailConfirmChange}
          />

          <RaisedButton
            fullWidth
            secondary
            disabled={!canContinue}
            label={getIntlMessage('Continue')}
            onTouchTap={this.setGiftEmail}
          />
        </div>
        <h4 className={css.logo}>
          <PoweredBy color={'#777'} borderColor={'#777'} />
        </h4>
      </div>
    );
  }
}

export default GiftEmailForm;



// WEBPACK FOOTER //
// ./src/js/components/GiftEmailForm.js